import {MainVideoState} from "../definitions/MainVideoState";

export const exitFullScreen = (state: MainVideoState) => {
    state.projectState.showFullScreen = false;
    state.projectState.showFullScreenControlBar = false;
};
